import httpClient from "./httpClient";
import * as zip from "@zip.js/zip.js";

class AssetService {
    async getAssets(channelGuid, data) {
        return httpClient(`/${channelGuid}/assets`, { method: "POST", body: data });
    }

    async updateDownloadCount(channelGuid, data) {
        return httpClient(`/${channelGuid}/assets/download-count`, { method: "POST", body: data });
    }

    async downloadAsset(assetDetails = [], setProgress) {
        setProgress(0);
        const writer = new zip.BlobWriter();
        const zipWriter = new zip.ZipWriter(writer, { level: 9 });

        try {
            const downloadPromises = assetDetails.map(asset =>
                fetch(asset?.downloadUrl, { mode: "cors", cache: "no-cache" })
            );

            const downloadedAssets = await Promise.all(downloadPromises);
            let completed = 0;

            for (let i = 0; i < downloadedAssets.length; i++) {
                try {
                    const asset = assetDetails[i];
                    const assetBlob = await downloadedAssets[i].blob();
                    const urlParts = asset?.downloadUrl.split('.');
                    const extension = urlParts.length > 1 ? urlParts.pop().split(/[?#]/)[0] : 'unknown';

                    await zipWriter.add(`${asset?.title}.${extension}`, new zip.BlobReader(assetBlob));
                    completed++;
                    setProgress(Math.round((completed / assetDetails.length) * 100));
                } catch (error) {
                    console.error("ERROR ON DOWNLOAD %O", error);
                    return false;
                }
            }

            const blob = await zipWriter.close();
            const zipUrl = URL.createObjectURL(blob);
            const tempLink = document.createElement('a');
            tempLink.href = zipUrl;
            tempLink.download = 'download.zip';
            tempLink.click();
            URL.revokeObjectURL(zipUrl);
            return true;
        } catch (error) {
            console.error("ERROR ON DOWNLOAD %O", error);
            return false;
        }
    }
}

export default new AssetService(); 